const initialState = {
    refDataEventsBySource: [],
    dbImportColumns: [],
    refDataConnectionDetails: [],
    serverFolderPaths: [],
    allXSDTemplates: [],
    isAutoMap: false,
};
export default initialState;
